import { createConnectedProperty } from "@primaria/plugins-core";
import { store } from "./store";

export function connectedProperty(selector: (state: any) => any, options: any = {}) {
  return createConnectedProperty(store)(selector, options);
}
